import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Form, reduxForm } from 'redux-form';
import { relationFilterByNormal } from '../../../helpers/common/ProfessionalInformationHelper';
import { propBool, propStr, ReduxFormProps, } from '../../../helpers/custom-prop-types';
import { consultantValidate } from '../../../validate/custom/profile';
import InputError from '../../Ui/Common/InputError';
import BaseSection from './PartsSection/BaseSection';
import OrganizationSection from './PartsSection/OrganizationSection';
import YourSection from './PartsSection/YourSection';
const FormProfileEditInner = (props) => {
    const { error, formName, handleSubmit, submitFailed, useProffit, useProffitMart, } = props;
    const { baseSkills: rawBaseSkills, experienceClasses: rawExperienceClasses, experiencedIndustryClasses: rawExperiencedIndustryClasses, largeTasks: rawLargeTasks, middleTasks: rawMiddleTasks, personalities, } = useSelector((state) => ({
        baseSkills: state.category.baseSkills,
        experienceClasses: state.category.experienceClasses,
        experiencedIndustryClasses: state.category.experiencedIndustryClasses,
        largeTasks: state.category.largeTasks,
        middleTasks: state.category.middleTasks,
        personalities: state.category.personalities,
    }));
    const { baseSkills, experienceClasses, experiencedIndustryClasses, largeTasks, middleTasks, } = useMemo(() => {
        const filterExperienceClasses = (rawExperienceClasses || []).filter(relationFilterByNormal);
        const filterLargeTasks = (rawLargeTasks || []).filter(relationFilterByNormal);
        const largeTaskIdList = (filterLargeTasks || []).map((v) => v.id);
        const filterMiddleTasks = (rawMiddleTasks || []).filter(({ largeTaskId }) => largeTaskIdList.includes(largeTaskId));
        const filterExperiencedIndustryClasses = (rawExperiencedIndustryClasses || []).filter(relationFilterByNormal);
        const filterBaseSkills = (rawBaseSkills || []).filter(relationFilterByNormal);
        return {
            baseSkills: filterBaseSkills,
            experienceClasses: filterExperienceClasses,
            experiencedIndustryClasses: filterExperiencedIndustryClasses,
            largeTasks: filterLargeTasks,
            middleTasks: filterMiddleTasks,
        };
    }, [
        rawMiddleTasks,
        rawBaseSkills,
        rawExperienceClasses,
        rawExperiencedIndustryClasses,
        rawLargeTasks,
    ]);
    return (_jsxs(Form, Object.assign({ className: 'form-white', onSubmit: handleSubmit }, { children: [_jsx(BaseSection, {}), _jsx(OrganizationSection, { form: formName, useProffit: useProffit, useProffitMart: useProffitMart }), _jsx(YourSection, { baseSkills: baseSkills, experienceClasses: experienceClasses, experiencedIndustryClasses: experiencedIndustryClasses, form: formName, largeTasks: largeTasks, middleTasks: middleTasks, personalities: personalities, submitFailed: !!submitFailed, useProffitMart: useProffitMart }), _jsx("div", Object.assign({ className: 'contents-footer-nav' }, { children: _jsx(InputError, { error: error }) }))] })));
};
FormProfileEditInner.propTypes = Object.assign({}, ReduxFormProps);
const form = reduxForm({
    asyncBlurFields: ['information.relatedSolutions[].url'],
    asyncValidate: consultantValidate.asyncForm,
});
const FormProfileEdit = form(FormProfileEditInner);
FormProfileEdit.propTypes = {
    formName: propStr().isRequired,
    useProffit: propBool().isRequired,
    useProffitMart: propBool().isRequired,
};
export default FormProfileEdit;
